import { RouteAddress } from './route-address.model';

export class RouteModel {
    public results: Array<RouteAddress>;
    public summary: any;
}
